<template>
  <Spinner v-if="loading"></Spinner>
  <div v-else>
    <v-snackbar center color="green" v-model="snackbar">
      <div class="text-center">{{ message }}</div>
    </v-snackbar>

    <!--<AddEditPoll
      @dialog="dialog = $event"
      @update="[(selectedPoll = $event), buildTable()]"
      :dialog="dialog"
      :poll="selectedPoll"
    />-->
    <v-breadcrumbs :items="crumbs">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-data-table :headers="headers" :items="votes" dense>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Manage Votes</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn @click="handleDownloadReport" color="primary" small
            >Export</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item[`actions`]="{ item }">
        <v-icon small class="mr-2" @click="editUser(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteUser(item)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:item.lastName="{ item }">
        {{ item.firstName }} {{ item.lastName }}
      </template>
      <template v-slot:item.voteResponse="{ item }">
        {{ item.voteResponse.join(", ") }}
      </template>
      <template v-slot:item.count="{ item }">
        <span v-if="item.count">
          {{ item.count }}
        </span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import api from "@/services/api";
import { mapState } from "vuex";
import Spinner from "@/components/Elements/Spinner.vue";
export default {
  components: {
    Spinner
  },
  data: () => ({
    loading: false,
    votes: [],
    headers: [
      { text: "Name", value: "lastName" },
      { text: "Poll", value: "pollText" },
      { text: "Response", value: "voteResponse" },
      { text: "Proxy", value: "count" },
      { text: "When", value: "updatedAt" }
    ],
    crumbs: [
      {
        text: "Home",
        to: "/admin",
        exact: true
      },
      {
        text: "Polls",
        to: "/admin/polls",
        exact: true
      }
    ],
    snackbar: false,
    message: ""
  }),
  computed: {
    ...mapState({ event: (state) => state.events.event })
  },

  async created() {
    this.loading = true;
    this.votes = await api.getVotes(this.event._id);
    this.loading = false;
  },
  methods: {
    async handleDownloadReport() {
      try {
        await api.exportReport(this.event._id);
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
